import { defineFeature } from '../define-feature';
import { SeoSpaceTab, seoSpaceWebPath } from '../../seo/seo-space-routes';

export default defineFeature({
  id: 'marketing.seo_pack.topics',
  category: 'marketing',
  title: 'Choisir les sujets du mois et lancer la rédaction',
  intent:
    "Chaque mois, dire oui ou non aux sujets d'articles proposés pour le mois suivant, puis lancer la rédaction du lot en une fois.",
  context: {
    why: "Le moteur cherche ce que vos clients tapent sur Google (votre métier, vos prestations, votre ville, ce que publient vos concurrents) et vous propose un peu plus de sujets que de dates à pourvoir. Vous tranchez en deux minutes ; vos refus affinent les propositions suivantes. Rien ne part en rédaction tant que le mois n'est pas trié : vous savez exactement ce qui sera publié.",
    use_cases: [
      'Écarter un sujet qui ne correspond pas à votre pratique (« je ne fais pas de cryolipolyse »).',
      'Ajouter un sujet à vous (« je veux un article sur ma nouvelle cabine »).',
      "Demander d'autres propositions quand celles du mois ne vous plaisent pas.",
    ],
  },
  required_scopes: ['website.seo_articles'],
  prerequisites: [
    {
      ref: 'marketing.seo_pack.overview',
      requirement: 'required',
      why: "Les sujets ne sont proposés qu'une fois le parcours de première activation suivi.",
    },
  ],
  ui_entry_points: [
    {
      route: seoSpaceWebPath(SeoSpaceTab.ARTICLES, { topics: true }),
      element:
        'Onglet « Articles », bouton « Choisir mes sujets » (ou lien de l’e-mail « Vos sujets de… » du mois concerné)',
    },
  ],
  api: {
    primary_operation_id: 'SeoContentAppController_launch',
    related_operation_ids: [
      'SeoContentAppController_topics',
      'SeoContentAppController_decide',
      'SeoContentAppController_propose',
      'SeoContentAppController_pack',
    ],
  },
  steps: [
    "**Vers le 10 du mois** (ou dès la fin du parcours d'activation), vous recevez l'e-mail « Vos sujets de… sont prêts » pour le mois suivant. Ouvrez l'espace référencement, onglet Articles.",
    "**Dites oui ou non à chaque sujet.** Le motif du refus est facultatif, mais il oriente la recherche suivante. Un « non » ne relance rien tout seul : à la fin de votre tri, lancez la rédaction ou demandez d'autres propositions.",
    '**Ajoutez vos propres sujets** si vous le souhaitez (« Ajouter ce sujet ») : ils comptent comme un oui.',
    "**Lancez la rédaction** quand chaque date libre du mois a son sujet et qu'aucune recherche n'est en cours : le bouton indique le nombre d'articles qui partent.",
    "**Pas assez de sujets qui vous plaisent ?** Demandez d'autres propositions (trois recherches par mois visé, les sujets refusés comptent), ajoutez un sujet libre (dix par mois), ou écrivez au support.",
  ],
  gotchas: [
    "**Le lot ne part que complet** : un oui pour chaque date libre du mois, aucune recherche en cours. Un lot incomplet ne part jamais, même s'il ne reste rien à trancher.",
    '**Les oui en trop et les sujets non tranchés suivent au mois suivant**, vos choix sont conservés.',
    "**Un mois qui commence sans lancement n'est pas rattrapé** (pas assez de oui, pas de clic) : ses dates restent vides. Vous êtes relancé par e-mail 10 et 18 jours après la proposition des sujets.",
    "**Un sujet peut encore être écarté au moment d'écrire** (même sujet qu'un article déjà rédigé, classement de prestataires, sujet de prix sans tarif à votre catalogue, plan impossible à sourcer) : il reste dans votre liste avec le motif, et sa date passe au prochain oui en réserve, de ce mois ou du suivant. Sans réserve, la date reste vide.",
    "**Une recherche peut ne rien donner** : l'espace référencement vous le dit, notre équipe est prévenue et relance la recherche pour vous une fois la cause corrigée.",
    "**Un sujet déjà couvert par une page de votre site n'est jamais proposé** : le moteur évite de concurrencer vos propres pages.",
    "**Référencement local** : un même sujet n'est proposé que pour une ville à la fois ; les villes tournent d'un mois sur l'autre.",
  ],
  related_features: ['marketing.seo_pack.overview', 'marketing.seo_pack.articles', 'marketing.seo_pack.options'],
});
